module.exports = __webpack_public_path__ + "img/Machine3.053d5950.svg";